import { graphql } from "./generated/gql";

export const TermReportQuery = graphql(`
  query TermReport($termId: ID!) {
    termReport(termId: $termId) {
      termId
      title
      description
      totalCompleted
      interviews {
        interviewId
        startTime
        endTime
        status
        satisfactionScore
        behaviorChangeScore
        completedAt
        summaryCheckCompletedAt
        candidate {
          candidateId
          name
          email
        }
        interviewer {
          interviewerId
          name
          email
        }
        summaryItems {
          summaryItemId
          interviewId
          category
          content
          useCaseId
          order
          createdAt
          updatedAt
        }
      }
    }
  }
`);
